module.exports = __webpack_public_path__ + "icon_email-ed5d2a37fa765e4c5fec080a82b0a783.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_email.png
// module id = 273
// module chunks = 88